import { Component, computed, effect, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EnabledPhotosHistoryDataResponse } from 'dashboard/components/visuals-dashboard/widgets/enabled-photos-history-widget/enabled-photos-history-data-response.interface';
import { mapLongIceDateToDisplayDate } from 'dashboard/helpers/ice-date-mapper';
import { DashboardWidget } from 'dashboard/interfaces/visuals/dashboard-widget.interface';
import { VisualsDashboardDataService } from 'dashboard/services/visuals-dashboard/visualds-dashboard-data.service';
import {
    ChartSeries,
    IceVisualsDashboardLineChartComponent,
} from 'shared/components/ice-visuals-dashboard/ice-visuals-dashboard-line-chart/ice-visuals-dashboard-line-chart.component';

@Component({
    selector: 'app-enabled-photos-history-widget',
    imports: [IceVisualsDashboardLineChartComponent, TranslateModule],
    templateUrl: './enabled-photos-history-widget.component.html',
    styleUrl: './enabled-photos-history-widget.component.scss',
    providers: [VisualsDashboardDataService],
})
export class EnabledPhotosHistoryWidgetComponent {
    widget = input.required<DashboardWidget>();
    pickedPeriodValue = input<number | null>(null);
    onLangChange = toSignal(this.translate.onLangChange);

    widgetId = computed(() => {
        const widget = this.widget();
        return widget.iceDashboardWidget.widgetId;
    });

    chartData = computed<number[]>(() => {
        const widgetData = this.dataService.data();
        return widgetData ? widgetData.data : [];
    });

    chartSeries = computed<ChartSeries[]>(() => {
        const widgetData = this.dataService.data();
        this.onLangChange(); // Trigger recomputation on language change
        if (!widgetData) {
            return [];
        }
        return [
            {
                name: this.translate.instant('dashboard.visuals.widgets.enabledPhotosHistory.seriesName'),
                data: widgetData.data,
                color: '#3B82F6',
            },
        ];
    });

    chartLabels = computed<string[]>(() => {
        const widgetData = this.dataService.data();
        if (!widgetData) {
            return [];
        }
        return widgetData.labels.map((label) => mapLongIceDateToDisplayDate(label));
    });

    constructor(
        public dataService: VisualsDashboardDataService<EnabledPhotosHistoryDataResponse>,
        private translate: TranslateService,
    ) {
        effect(() => {
            const widgetId = this.widgetId();
            const periodValue = this.pickedPeriodValue();
            if (widgetId !== null && periodValue !== null) {
                this.dataService.load(widgetId, periodValue);
            }
        });
    }
}
